import React from 'react'

const SigninPage = () => {
    return (
        <div>
            <h1>Sign in</h1>
        </div>
    )
}

export default SigninPage
